import { ISingleIdParams } from '../types/actionParams';
import { IProjectName } from '../types/IProject';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetProjectAncestorsResult extends IResult {
  projects: IProjectName[];
}

export class GetProjectAncestorsRequest extends Request<ISingleIdParams, IGetProjectAncestorsResult> {
  constructor(projectId: string) {
    super('getProjectAncestors', { id: projectId });
  }
}
